import Head from 'next/head'
import Script from 'next/script'
import { BlogHeaderLinks } from '../../../../components/blogs/BlogHeaderLinks'
import { contentDate } from '../../../../utils/article-date-time'
import { blogsMaster } from '../../../../utils/sg-blogs-data'
import { getWpNewPostsByCategory, getWpPostsByCategory } from '../../../../lib/service'
import { Beauty } from '../../../../components/blogs/Beauty'

// When this page's content last actually changed. Bump it by hand when you
// edit the copy - not for layout/UX changes. Feeds dateModified and
// article:modified_time (see reviewedIso in utils/article-date-time).
const CONTENT_REVIEWED = '2026-09-22'

export async function getStaticProps() {

    const { modifiedDate, month, year } = contentDate(CONTENT_REVIEWED);

    const latestBlogs = blogsMaster['beauty-wellness'].blogArray;

    const wpPosts = await getWpPostsByCategory(100, "beauty-wellness");
    const wpNewPosts = await getWpNewPostsByCategory(100, "beauty-wellness"); // retrieve first 100 posts

  return {
      props: {
        modifiedDate,
        month,
        year,
        latestBlogs,
        wpPosts,
        wpNewPosts
      },
      // Next.js will attempt to re-generate the page:
      // - When a request comes in
      // - At most once every 10 seconds
      revalidate: 86400, // In seconds
  }
}

export default function Home(props) {
    const modifiedDate = props.modifiedDate
    const month = props.month
    const year = props.year
    const latestBlogs = props.latestBlogs
    const wpPosts = props.wpPosts
    const wpNewPosts = props.wpNewPosts

  return (
    <>
      <Head>
        <title>{`Blog Articles On Beauty & Wellness | StringsSG`}</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="description" content="Through these articles learn about how to take care of you overall beauty. Tips and hacks on hair, nail and skin care."/>
        <meta name="keywords" content="House Rental, Insurance Plan, Personal Trainer, Maid Service, Handyman Service, Aircon Service, Savings Plan, Food Catering, Interior Design, Wedding Planner, Event Planner"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:url"   content="https://www.stringssg.com/sg/blogs/beauty-wellness" />
        <meta property="og:type"   content="article" />
        <meta property="og:title"    content={`Blog Articles On Beauty & Wellness | StringsSG`}/>
        <meta property="og:description" content="Through these articles learn about how to take care of you overall beauty. Tips and hacks on hair, nail and skin care." />
        <meta property="article:publisher" content="https://www.facebook.com/StringsSG/" />
        <meta property="article:published_time" content="2025-01-05T07:30:46+00:00" />
        <meta property="article:modified_time" content={`${modifiedDate}`} />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/beauty-service.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/beauty-service.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/sg/blogs/beauty-wellness"/>
        <meta name="twitter:title" content={`Blog Articles On Beauty & Wellness | StringsSG`}/> 
        <meta name="twitter:description" content="Through these articles learn about how to take care of you overall beauty. Tips and hacks on hair, nail and skin care."/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/sg/blogs/beauty-wellness" />
        <script type="application/ld+json"
          dangerouslySetInnerHTML={{ __html:
            `{"@context":"https://schema.org","@graph":[{"@context":"https://schema.org/","@type":"BlogPosting","mainEntityOfPage":{"@type":"WebPage","@id":"https://www.stringssg.com/sg/blogs/beauty-wellness"},"headline":"Blog Articles On Beauty & Wellness | StringsSG","description":"Through these articles learn about how to take care of you overall beauty. Tips and hacks on hair, nail and skin care.","image":["https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/beauty-service.png"],"author":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/"},"publisher":{"@type":"Organization","@id":"https://www.stringssg.com/#organization","name":"StringsSG","url":"https://www.stringssg.com/","logo":{"@type":"ImageObject","url":"https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/logo.png"}},"datePublished":"2025-01-06T07:30:46+00:00","dateModified":"${modifiedDate}"},{"@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Blogs","item":"https://www.stringssg.com/sg/blogs"},{"@type":"ListItem","position":2,"name":"beauty-wellness"}]}]}`
          }}
        />
      </Head>
      <div className='max-w-5xl mx-auto py-10'>
            <Beauty latestBlogs={latestBlogs} wpPosts={wpPosts} wpNewPosts={wpNewPosts}/>
      </div>
      <h2 className='bg-gray-800 text-white py-4 p-2 text-center text-2xl'>
          Topics
      </h2>
      <BlogHeaderLinks/>
      <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
      />
      <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}
